import * as types from '../mutation-types';
import config from '@/config';
import { loadData } from '@/utils/loading';


const state = {
  permissions: null,
};

const mutations = {
  [types.SET_PERMISSIONS]: (state, permissions) => {
    state.permissions = permissions;
  },
};

const getters = {
};

const actions = {
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
